<form [formGroup]="mainForm">
  <table mat-table [dataSource]="dataSource" formArrayName="lineItems" class="table">
    <ng-container matColumnDef="category">
      <th mat-header-cell *matHeaderCellDef>Category</th>
      <td mat-cell *matCellDef="let element; let index = index" [formGroupName]="index">
        {{ element.get('category').value }}
      </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-cell *matCellDef="let element; let index = index" [formGroupName]="index" class="table-form">
        <mat-form-field class="full-width">
          <input formControlName="description" matInput maxlength="255">
          @if (element.get('description').hasError('maxlength')) {
            <mat-error>
              Description must be less than 255 characters.
            </mat-error>
          }
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef>Qty</th>
      <td mat-cell *matCellDef="let element; let index = index" [formGroupName]="index" class="table-form">
        <mat-form-field class="wid-90">
          <input formControlName="quantity" matInput type="number">
          @if (element.get('quantity').hasError('min')) {
            <mat-error>
              Quantity must be greater than or equal to 0.
            </mat-error>
          }
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="price">
      <th mat-header-cell *matHeaderCellDef>Price</th>
      <td mat-cell *matCellDef="let element; let index = index" [formGroupName]="index" class="table-form">
        <mat-form-field class="wid-90">
          <input formControlName="price" matInput type="number" step="0.01">
          @if (element.get('price').hasError('min')) {
            <mat-error>
              Price must be greater than or equal to 0.
            </mat-error>
          }
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="discount">
      <th mat-header-cell *matHeaderCellDef>Discount</th>
      <td mat-cell *matCellDef="let element; let index = index" [formGroupName]="index" class="table-form">
        <mat-form-field class="wid-90">
          <input formControlName="discount" matInput type="number" step="0.01">
          @if (element.get('discount').hasError('min')) {
            <mat-error>
              Discount must be a positive number.
            </mat-error>
          }
          @if (element.get('discount').hasError('discountLessThanPrice')) {
            <mat-error>
              Discount must be less than the price.
            </mat-error>
          }
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>Total</th>
      <td mat-cell *matCellDef="let element; let index = index" [formGroupName]="index" class="table-form">
        <mat-form-field class="wid-120">
          <input formControlName="total" matInput>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <lib-button (click)="deleteLineItem(element)" icon="delete"></lib-button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div form-actions class="flex-row gap-16 mt-16">
    <lib-button variant="stroked"
      *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]" (click)="addLineItem()"
      icon="add">Add Line Item</lib-button>
    <lib-button variant="stroked"
     *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]" (click)="removeAllLineItems()" icon="remove">Remove
      All Line Items</lib-button>
  </div>
  <mat-form-field appearance="fill" class="full-width">
    <mat-label>Note</mat-label>
    <textarea matInput formControlName="note" maxlength="5000"></textarea>
  </mat-form-field>

  <lib-multi-labels [readOnly]="true" [placeholder]="'Tags'" [labels]="tags" [readonlyLabels]="[]"></lib-multi-labels>

  <mat-form-field appearance="fill">
    <mat-label>Number of Stamps</mat-label>
    <input matInput type="number" min="1" max="100" step="1" formControlName="numberOfStamps">
  </mat-form-field>

  <div class="flex-row gap-16">
    <lib-button class="btn-give-stamps"
      *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]"
      variant="stroked" color="primary" (buttonClick)="giveStamps()">
      Give Extra stamps/points
      @if (isGiveStampsChecked) {
        <mat-icon>checked</mat-icon>
      }
    </lib-button>

    <lib-button class="btn-check-eligible" [disabled]="checkEligibleDisabled"
      *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]"
      variant="stroked" color="primary" (buttonClick)="checkEligible()">
      Check Eligible
      @if (isCheckEligibleChecked) {
        <mat-icon>checked</mat-icon>
      }
    </lib-button>

    <lib-button class="btn-check-fraud" [disabled]="checkFraudDisabled"
      *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]"
      variant="stroked" color="primary" (buttonClick)="checkFraud()">
      Check Fraud
      @if (isCheckFraudChecked) {
        <mat-icon>checked</mat-icon>
      }
    </lib-button>

    <lib-button class="btn-reject" [disabled]="rejectDisabled"
      *appHasAnyPermission="[permissions.CAMPAIGNMANAGEMENT_WRITE, permissions.CAMPAIGN_UPDATE]"
      variant="stroked" color="primary" (buttonClick)="reject()">
      Reject
      @if (isRejectChecked) {
        <mat-icon>checked</mat-icon>
      }
    </lib-button>
  </div>
</form>